import React, {Component, PropTypes} from 'react';

export default class Section extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        title: PropTypes.string,
    };

    static defaultProps = {
        title: undefined,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children
            || nextProps.title !== this.props.title;
    }

    render() {
        const {children, title} = this.props;
        return (
            <div className='cielo24-vwrap-form-section'>
                {title && <div className='cielo24-vwrap-title'>{title}</div>}
                {children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/forms/section.js